import React from 'react';
import { ContactUsForm, ContactUsFormProps } from './ContactUsForm';
import { useFetch } from '../../../utils/hooks/useFetch';
import { ContactUsApi } from '../../../api/base/ContactUs';
import { IContactUsForm } from '../../../api/base/ContactUs/types';
import { IDefaultSuccessResponse } from '../../../api/base/baseApiTypes';
import { useResponseFormHandler } from '../../../utils/hooks/useResponseFormHandler';

type ContactUsFormContainerProps = Pick<ContactUsFormProps, 'startTabIndex'> & {
  isVerticalForm?: boolean;
  title?: any;
};

export function useContactUsResponseFormHandler({
  response,
  error,
}: any): void {
  if (response?.data?.data === 'Success send form') {
    response.data.data = 'Form is sent successfully';
  }
  useResponseFormHandler({ response, error });
}
export const ContactUsFormContainer: React.FC<ContactUsFormContainerProps> = (
  props,
) => {
  const { isVerticalForm, title, startTabIndex } = props;
  const [{ response, isLoading, error }, doFetch] =
    useFetch<IDefaultSuccessResponse>(ContactUsApi.contactUs);

  useContactUsResponseFormHandler({ response, error });

  return (
    <ContactUsForm
      isVertical={isVerticalForm}
      loading={isLoading}
      errors={error?.response?.data.errors}
      onSubmit={(data: IContactUsForm) => {
        doFetch(data);
      }}
      title={title}
      startTabIndex={startTabIndex}
    />
  );
};
